import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=3d36ee5a&scoped=true&lang=css"

import exportComponent from "D:\\project\\哨兵官网\\Dtsc.Sentry.Offical.WebSite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d36ee5a"]])

export default __exports__